import React, { useEffect, useRef, useState } from "react";
import { Player } from "bitmovin-player";
import { UIFactory } from "bitmovin-player/bitmovinplayer-ui";
import { fetchPlayApiSource } from "@repo/utils";
import "bitmovin-player/bitmovinplayer-ui.css";

function BitmovinPlayer() {
  const [player, setPlayer] = useState(null);
  const playerDiv = useRef(null);

  const playerConfig = {
    key: "378a99c6-1097-4afa-a8a8-a70762280eb1",
    analytics: {
      key: "3f192444-fe35-4655-9b7d-ae3a30b0bc52",
    },
    ui: false,
    network: {
      preprocessHttpRequest: (type, request) => {
        if (type === "drm/certificate/fairplay") {
          request.responseType = "arraybuffer";
        }
        return Promise.resolve(request);
      },
    },
  };

useEffect(() => {
  let cancelled = false;
  let playerInstance = null;

  async function setupPlayer() {
    try {
      const AdvertisingBitmovinModule = (
        await import("bitmovin-player/modules/bitmovinplayer-advertising-bitmovin")
      ).default;

      let { srcCfg } = await fetchPlayApiSource(
        "https://api.dev.streaming.channel4.com/1.6/A/ENG/DOTCOM/ALL/PLAY/VOD/1000000028",
      );


            console.log(srcCfg);

      // temp hack
      //srcCfg.dash = "https://rdmedia.bbc.co.uk/testcard/simulcast/manifests/avc-ctv-en.mpd";
      srcCfg.dash = "https://rdmedia.bbc.co.uk/testcard/simulcast/manifests/avc-ctv-stereo-ad-no_subs-en.mpd";

      console.log(srcCfg);


      if (cancelled) return;

      Player.addModule(AdvertisingBitmovinModule);

      if (cancelled) return;
      if (!playerDiv.current) return;

      playerInstance = new Player(playerDiv.current, playerConfig);


      UIFactory.buildDefaultUI(playerInstance);



      await playerInstance.load(srcCfg);

      if (cancelled) return;

      setPlayer(playerInstance);
      console.log("Successfully loaded source");
    } catch (err) {
      if (!cancelled) console.warn(err);
    }
  }

  setupPlayer();

  return () => {
    cancelled = true;

    if (player != null) {
      player.destroy();
      setPlayer(null);
    }
  };
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);


  return <div>
    <div id="player" ref={playerDiv} />
    </div>;
}

export default BitmovinPlayer;
